import { useAuthSessionQuery } from "../../utils/useAuthSessionQuery";
import { Navigate } from "react-router-dom";
import getCSRFTokenFromCookie from "../../utils/getCSRFToken";
import { getUrl } from "../../App";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
async function logoutMutation() {
  await fetch(`${getUrl()}/_allauth/browser/v1/auth/session`, {
    credentials: "include",
    method: "DELETE",
    headers: { "X-CSRFTOKEN": getCSRFTokenFromCookie() || "" },
  });
}

export default function Logout() {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: logoutMutation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["authSession"] });
    },
  });

  useEffect(() => {
      mutate();
    }, []);

  return <Navigate to="/login" />;
}
